<template>
	<m-main-layout>
		<div class="text-right">
			<base-button type="primary" size="small" @click.native="toExport" :rule="'/company/'+searchForm.user_type+'/export'">导出</base-button>
		</div>
		<div>
			<el-form :model="searchForm" label-width="100px" inline>
				<el-form-item label="公司名称">
					<el-input v-model="searchForm.company"></el-input>
				</el-form-item>
				<el-form-item :label="searchForm.user_type === 'hz' ? '行业类型' : '客户类型'">
					<type-select v-model="searchForm.type_industry_ids" :can-add="false" :data="{akey:'industry'}"></type-select>
				</el-form-item>
				<el-form-item label="服务类型">
					<type-select v-model="searchForm.type_fuwu_ids" :can-add="false" :data="{akey:'fuwu'}"></type-select>
				</el-form-item>
				<el-form-item label="区域">
					<type-select v-model="searchForm.province_codes" url="/Area/listAll" :can-add="false" :data="{pid:['1','<='],orderBy:'code',sortBy:'asc'}" list-value="code"></type-select>
<!--					<area-select v-model="searchForm.province_codes" :data="{pid:['1','<=']}"></area-select>-->
				</el-form-item>
				<el-form-item label="状态">
					<type-select v-model="searchForm.state" :can-add="false" :options="[{id:'0',name:'待审核'},{id:'1',name:'已通过'},{id:'2',name:'已拒绝'}]"></type-select>
				</el-form-item>
				<el-form-item label="供应商类型" v-if="searchForm.user_type === 'gys'">
					<type-select v-model="searchForm.gys_type" :can-add="false" :options="[{id:'shebei',name:'设备'},{id:'wuliu',name:'物流'}]"></type-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="toSearch">搜索</el-button>
					<el-button type="info" @click="toReset">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div style="background-color: #eee;padding:10px;">
			合计数量：<b>{{totalCount}}</b>
			<template v-if="searchForm.user_type === 'gys'">
				<span style="padding:0 20px;color:#ddd;">|</span>
				合计自有车辆：<b>{{total_zyyl}}</b>辆
				<span style="padding:0 20px;color:#ddd;">|</span>
				合计冷库容量：<b>{{total_lkmj}}</b>m³
				<span style="padding:0 20px;color:#ddd;">|</span>
				合计常温库容量：<b>{{total_cwkmj}}</b>m³
			</template>
		</div>
		<div>
			<el-table :data="list" style="width: 100%">
				<el-table-column prop="uid" label="UID"></el-table-column>
				<el-table-column prop="company" label="公司名称"></el-table-column>
				<el-table-column prop="user_type" label="身份">
					<template slot-scope="scope">
						<span v-if="scope.row.user_type === 'hz'">货主</span>
						<span v-if="scope.row.user_type === 'gys'">供应商</span>
					</template>
				</el-table-column>
				<el-table-column prop="user_type" label="供应商类型" v-if="searchForm.user_type === 'gys'">
					<template slot-scope="scope">
						<span v-if="scope.row.gys_type === 'wuliu'">物流</span>
						<span v-if="scope.row.gys_type === 'shebei'">设备</span>
					</template>
				</el-table-column>
				<el-table-column prop="logo" label="企业logo">
					<template slot-scope="scope">
						<el-image
							style="height: 60px"
							:src="scope.row.logo.indexOf('http')>= 0 ? scope.row.logo : $config.assetsUrl + scope.row.logo"
							:preview-src-list="scope.row.logo.indexOf('http')>= 0 ? [scope.row.logo] : [$config.assetsUrl + scope.row.logo]" v-if="scope.row.logo">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="industry_str" label="行业类型" v-if="searchForm.user_type === 'hz'"></el-table-column>
				<el-table-column prop="industry_str" label="客户类型" v-if="searchForm.user_type === 'gys'"></el-table-column>
				<el-table-column prop="fuwu_str" label="服务类型" v-if="searchForm.user_type === 'gys'"></el-table-column>
				<el-table-column prop="area_str" label="区域"></el-table-column>
				<el-table-column prop="state" label="状态">
					<template slot-scope="scope">
						<el-tag type="warning" v-if="scope.row.state === 0">待审核</el-tag>
						<el-tag type="success" v-if="scope.row.state === 1">已通过</el-tag>
						<el-tag type="danger" v-if="scope.row.state === 2">已拒绝</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="reason" label="拒绝原因"></el-table-column>
				<el-table-column prop="update_time" label="最后提交时间"></el-table-column>
				<el-table-column label="是否推荐" v-if="searchForm.user_type === 'gys'">
					<template slot-scope="scope">
						<el-switch
							v-model="scope.row.is_tuijian"
							active-color="#13ce66"
							:active-value="1"
							:inactive-value="0"
							@change="changeStatus(scope.row.id,scope.row)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
<!--						<el-button type="text" class="warning" @click="toCheck(scope.row)">审核</el-button>-->
						<base-button type="text" size="medium" class="warning" @click.native="toCheck(scope.row)" :rule="'/company/'+searchForm.user_type+'/check'">审核</base-button>
						<base-button type="text" size="medium" class="success" @click.native="toEdit(scope.row)" :rule="'/company/'+searchForm.user_type+'/edit'">编辑</base-button>
<!--						<el-button type="text" class="danger" @click="toEdit(scope.row)">编辑</el-button>-->
<!--						<el-button type="text" @click="toDetail(scope.row)">详情</el-button>-->
					</template>
				</el-table-column>
			</el-table>
			<div class="padding-top-bottom-20 text-center">
				<el-pagination
					background
					layout="total,prev, pager, next"
					:page-size="searchForm.pageSize"
					:current-page.sync="searchForm.page"
					:total="totalCount"
					@current-change="pageChange">
				</el-pagination>
			</div>
		</div>
	</m-main-layout>
</template>

<script>
export default {
	name: "list",
	data() {
		return {
			list: [],
			totalPage:0,
			totalCount:0,
			total_zyyl:0,
			total_lkmj:0,
			total_cwkmj:0,
			searchForm:{
				page:1,
				pageSize:10,
				user_type:'',
				company:'',
				contact:'',
				phone:'',
				state:'',
				province_codes:'',
				type_industry_ids:'',
				type_fuwu_ids:'',
				orderBy:'update_time',
				sortBy:'desc'
			},
			usertype:''
		}
	},
	created() {
		this.searchForm.user_type = this.$route.params.usertype ? this.$route.params.usertype : '';
		this.searchForm = this.$route.query ? {...this.searchForm,...this.$route.query} : {...this.searchForm};
		this.searchForm.page = parseInt(this.searchForm.page);
		this.searchForm.pageSize = parseInt(this.searchForm.pageSize);
	},
	mounted() {
		this.getList();
	},
	methods: {
		toExport(){
			let _this = this;
			this.$http.httpPost({
				url: '/UserCompany/export',
				datas: this.searchForm,
				showLoad:true,
				download: true,
				success(res) {
					const blob = new Blob([res])
					const fileName = (_this.searchForm.user_type === 'hz' ? '货主信息导出' : '供应商信息导出') + '_' + _this.$moment().format('YYYYMMDDHHmmss') + '.xlsx';
					const link = document.createElement('a')
					link.download = fileName;
					link.style.display = 'none'
					link.href = URL.createObjectURL(blob)
					document.body.appendChild(link)
					link.click();
					URL.revokeObjectURL(link.href);
					document.body.removeChild(link);
				}
			});
		},
		toSearch() {
			this.searchForm.page = 1
			this.$router.replace({query:{...this.searchForm}});
		},
		toReset(){
			this.searchForm.page = 1;
			this.searchForm.company = '';
			this.searchForm.contact = '';
			this.searchForm.phone = '';
			this.searchForm.state = '';
			this.searchForm.province_codes = '';
			this.searchForm.type_industry_ids = '';
			this.searchForm.type_fuwu_ids = '';
			this.searchForm.gys_type = '';

			this.$router.replace({query:{...this.searchForm}});
		},
		changeStatus(index, row) {
			let _this = this;
			let _text = '';
			let _status = '';
			let flag = row.is_tuijian;

			if (row.is_tuijian === 0 || row.is_tuijian === 1) {
				if (row.is_tuijian === 1) {
					_text = '是否推荐该供应商？';
					_status = 1;
				} else if (row.is_tuijian === 0) {
					_text = '是否取消推荐该供应商？';
					_status = 0;
				}
				this.$confirm(_text, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				})
					.then(() => {
						if (_status === 0 || _status === 1) {
							this.$http.httpPost({
								url: '/UserCompany/changeState',
								datas: {id:row.id,is_tuijian: _status},
								method:'post',
								success(res) {
									_this.$utils.success("操作成功！");
									_this.getList();
								},
								fail(err){
									if (flag === 1) {
										row.is_tuijian = 0;
									} else {
										row.is_tuijian = 1;
									}
									_this.$utils.error(err.msg);
								}
							});
						}
					})
					.catch((err) => {
						// console.log(err);
						if (flag === 1) {
							row.is_tuijian = 0;
						} else {
							row.is_tuijian = 1;
						}
					});
			} else {
				this.$utils.warning('操作异常');
			}
		},
		getList(){
			let _this = this;
			this.dataList = [];
			this.$http.httpPost({
				url:'/UserCompany/listPage',
				datas:{...this.searchForm},
				success(res){
					console.log(res);
					_this.list = res.list;
					_this.totalCount = res.totalCount;

					if(res.total_cwkmj){
						_this.total_cwkmj = res.total_cwkmj;
					}

					if(res.total_zyyl){
						_this.total_zyyl = res.total_zyyl;
					}

					if(res.total_lkmj){
						_this.total_lkmj = res.total_lkmj;
					}
				}
			})
		},
		pageChange(page){
			this.page = page;
			// this.getList();
			this.$router.replace({query:{...this.searchForm}})
		},
		toDetail(row){
			this.$router.push({path:'/company/'+this.searchForm.user_type+'/detail',query:{id:row.id}});
		},
		toCheck(row){
			this.$router.push({path:'/company/check/',query:{id:row.id}});
		},
		toEdit(row){
			this.$router.push({path:'/company/edit',query:{id:row.id}});
		},
	}
}
</script>
